module.exports = __webpack_public_path__ + "static/media/calendar-icon.c44cc4bb.svg";